import { Box, Button, FormControlLabel, Typography, Checkbox as MuiCheckbox } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import selectOptions from '../../constants/selectOptions'
import CardTAG from '../CardTAG'
import DividerTAG from '../DividerTAG'
import Dropdown from '../Dropdown'
import PageBodyLayout from '../PageBodyLayout'
import ReportSubheader from '../ReportSubheader'

import { ReactComponent as DownIcon } from '../../assets/images/DownIcon.svg'
import colors from '../../constants/colors'
import Checkbox from '../Checkbox'
import FormLayout from '../forms/FormLayout'
import ModalTAG from '../ModalTAG'
import reportsService from '../../services/reportsService'
import { useSelector } from 'react-redux'
import reportsSelectors from '../../store/reports/reportsSelectors'

import { info } from '../../utils/alertUtils';

const pages = [
  {
    url: '/images/exportReportCsvTemplate.png',
    id: 1,
  },
  {
    url: '/images/exportReportCsvTemplate.png',
    id: 2,
  },
  {
    url: '/images/exportReportCsvTemplate.png',
    id: 3,
  },
  {
    url: '/images/exportReportCsvTemplate.png',
    id: 4,
  },
]

const imageHoverStyle = {
  height: '90%',
  borderRadius: '5rem',
  position: 'relative',
  ':before': {
    content: '""',
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(0,0,0,0)',
  },

  ':hover::before ': {
    backgroundColor: colors.TAG_SECONDARY_BLUE,
    opacity: 0.5,
  },

  button: {
    position: 'absolute',
    top: '60%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    ' -ms-transform': 'translate(-50%, -50%)',
    opacity: 0,
  },

  ':hover button': {
    opacity: 1,
  },
}

const ExportCase: React.FC = () => {
  const [selectPages, setSelectPages] = useState<string>('all')
  const [enlargedPhoto, setEnlargedPhoto] = useState<{ url: string; id: number }>()
  const selectedReport = useSelector(reportsSelectors?.selectedReport)
  const formMethods = useForm<{
    exportType: 'caseFile'
    anonymize: false
    includeAttachments: false
    pagesRange: ''
  }>({
    defaultValues: {},
    mode: 'onChange',
    shouldFocusError: false,
  })

  const { register, handleSubmit, formState, control, watch } = formMethods

  const exportTypeValue = watch('exportType') as string
  const anonymizeValue = watch('anonymize') as boolean
  const includeAttachmentsValue = watch('includeAttachments') as boolean

  const getMessage = useCallback(
    (field: 'exportType' | 'anonymize' | 'includeAttachments' | 'pagesRange') => {
      if (!formState.errors[field]) return ''

      return formState.errors[field]!.message
    },
    [formState],
  )

  const handleSelectPages = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectPages((event.target as HTMLInputElement).value)
  }

  const handleExport = (data: any) => {
    // eslint-disable-next-line
  }

  const renderPages = () => {
    return pages.map((page, index) => {
      return (
        <Box sx={{ height: '42.3rem', width: '22.5%' }} key={page.id}>
          <Box sx={imageHoverStyle} key={page.id}>
            <img src={page.url} style={{ objectFit: 'cover', width: '100%', height: '100%' }} />
            <Button
              className='enlargeButton'
              onClick={() => {
                setEnlargedPhoto(page)
              }}
            >
              <Typography variant='bodyBold' color={colors.WHITE}>
                {' '}
                View Enlarged
              </Typography>
            </Button>
          </Box>
          <FormControlLabel
            control={<MuiCheckbox value={true} />}
            label={<Typography variant='bodyRegular'>Page {index + 1}</Typography>}
          />
        </Box>
      )
    })
  }

  const doExport = async (requestData: { [key: string]: string | Date }) => {
    const { data, status } = await reportsService.getReportExport(
      selectedReport?.id as number,
      requestData.as as string,
    )
    if (status == 204) {
      info('No data found for this set of filters')
      return
    }
    window.location.assign(data.link)
  }

  const exportHandler = () => {
    const requestObject = {
      as: exportTypeValue,
      ...(exportTypeValue === 'xls'
        ? {
            violence_type:
              'Criminal Intent,Customer / Client,Worker on Worker,Personal Relationship',
          }
        : {}),
    }

    doExport(requestObject)
  }

  return (
    <PageBodyLayout
      dataPart={
        <Box>
          <form onSubmit={handleSubmit(handleExport)}>
            <CardTAG title={'Export Case'}>
              <FormLayout>
                <Dropdown
                  control={control}
                  fieldName='exportType'
                  label=''
                  selectedValue={exportTypeValue}
                  options={selectOptions.exportCaseTypeOptions}
                  error={getMessage('exportType')}
                />
                <Box sx={{ width: '100%', display: 'flex', alignItems: 'start' }}>
                  <Checkbox
                    control={control}
                    fieldName={'anonymize'}
                    value={anonymizeValue}
                    label={'Anonymize this Report?'}
                  />

                  <Checkbox
                    control={control}
                    fieldName={'includeAttachments'}
                    value={includeAttachmentsValue}
                    label={'Include Attachments?'}
                  />
                </Box>
                <DividerTAG />
                {/*                 <Typography variant='h4'>Preview</Typography>
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '3.33%',
                    rowGap: '1.8rem',
                  }}
                >
                  {renderPages()}
                </Box> */}
                <Button
                  variant='outlined'
                  startIcon={<DownIcon fill={colors.BLACK} />}
                  sx={{ maxWidth: 'fit-content' }}
                  onClick={exportHandler}
                  disabled={!exportTypeValue}
                >
                  <Typography variant='bodyRegular' color='inherit'>
                    Export
                  </Typography>
                </Button>
              </FormLayout>
            </CardTAG>
          </form>

          <ModalTAG open={!!enlargedPhoto} style={{ width: '40%', height: '80' }}>
            <CardTAG
              closable={true}
              closeCard={() => {
                setEnlargedPhoto(undefined)
              }}
              title={`Photo ${enlargedPhoto?.id}`}
            >
              <img
                src={enlargedPhoto?.url}
                style={{ objectFit: 'cover', width: '100%', height: '100%' }}
              />
            </CardTAG>
          </ModalTAG>
        </Box>
      }
      filterPart={undefined}
      caseSubheader={<ReportSubheader />}
    />
  )
}

export default ExportCase
